import {
  Box,
  Button,
  H3,
  H5,
  H6,
  Label,
  Stack,
  Text,
  Badge
} from "@adfenix/alexandria";
import UilFacebook from "@iconscout/react-unicons/icons/uil-facebook-f";
import { FacebookIntegration } from "api/services/facebookService";
import cx from "classnames";
import PageItem from "./PageItem";
import { Li, StyledLevel, StyledLevelItem } from "./StyledElements";
import { useTranslation } from "react-i18next";
import ErrorMessageWithTitle from "./ErrorMessageWithTitle";

const ConnectPage = ({
  officeId,
  errorMessageTitle,
  errorMessageBody,
  existingHqIntegrationData,
  handleLogin
}: {
  officeId?: string;
  errorMessageTitle: string | undefined;
  errorMessageBody: string | undefined;
  existingHqIntegrationData: FacebookIntegration | undefined;
  handleLogin: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Stack spacing="l">
      <H3 style={{ marginBottom: 8 }}>
        {t("selfonboarding.connect.header.title")}
      </H3>

      <Box display="block" justifyContent="flex-start">
        {officeId ? (
          <Badge color="grey">
            {t("selfonboarding.connect.badge.office.notConnected")}
          </Badge>
        ) : (
          <Badge color="grey">
            {t("selfonboarding.connect.badge.notConnected")}
          </Badge>
        )}
      </Box>

      {existingHqIntegrationData?.facebookPageId && (
        <Stack spacing="xs">
          <H6>{t("selfonboarding.connect.hq.connectedPage.title")}</H6>
          <StyledLevel>
            <StyledLevelItem className={cx("checked")}>
              <PageItem
                pageData={{
                  facebook: {
                    facebookPageName:
                      existingHqIntegrationData.facebookPageName,
                    facebookPageUrl: existingHqIntegrationData.facebookPageUrl,
                    facebookProfilePicture:
                      existingHqIntegrationData.facebookProfileImage,
                    accessToken: "",
                    facebookPageId: existingHqIntegrationData.facebookPageId
                  },
                  instagram: {
                    instagramAccountName:
                      existingHqIntegrationData.instagramPageName,
                    instagramActorId:
                      existingHqIntegrationData.instagramActorId,
                    instagramProfilePicture:
                      existingHqIntegrationData.instagramProfileImage
                  }
                }}
              />
            </StyledLevelItem>
          </StyledLevel>
          <Box>
            <Text>
              {t("selfonboarding.connect.hq.connectedPage.description")}
            </Text>
          </Box>
        </Stack>
      )}
      {!existingHqIntegrationData?.facebookPageId && (
        <Text>{t("selfonboarding.connect.hq.connectPage.note")}</Text>
      )}

      {existingHqIntegrationData?.allowOfficeUsersToConfigureSettings ||
      !officeId ? (
        <Stack spacing="s">
          <H5 style={{ marginTop: 16 }}>
            {t("selfOnboarding.beforeStart.title")}
          </H5>

          <ul style={{ paddingLeft: 24 }}>
            <Li>{t("selfOnboarding.beforeStart.bullet1")}</Li>
            <Li>{t("selfOnboarding.beforeStart.bullet2")}</Li>
          </ul>

          <Text>{t("selfOnboarding.beforeStart.minimumPermission")}</Text>

          <Button
            logLabel="selfonboarding-connect-learn-more-button"
            onClick={() =>
              window.open(
                "https://help.adfenix.com/en/articles/6563635-connect-your-office-s-social-accounts-directly-on-the-platform",
                "_blank"
              )
            }
            variant="text"
          >
            {t("selfOnboarding.beforeStart.learnMore")}
          </Button>

          <ErrorMessageWithTitle
            title={errorMessageTitle}
            body={errorMessageBody}
          />

          <Button
            logLabel="selfonboarding-connect-button"
            onClick={handleLogin}
          >
            <Box display="flex">
              <UilFacebook size="20px" style={{ marginRight: 6 }} />{" "}
              <Label style={{ color: "white", cursor: "pointer" }}>
                {t("selfonboarding.connect.connectButton")}
              </Label>
            </Box>
          </Button>
        </Stack>
      ) : (
        <Text>{t("selfonboarding.connect.officesNotAllowed")}</Text>
      )}
    </Stack>
  );
};

export default ConnectPage;
